export default __webpack_public_path__ + "static/media/vf-reassigned.d64a7e0b.svg";